import { lazy, Suspense } from 'react';
import { redirect, RouteObject } from 'react-router-dom';
import { getUserInfoQuery } from '~/apis/auth';
import LoadingCircularProgress from '~/components/LoadingCircularProgress';
import { PiracySocialMediaRouteEnum, SocialMediaListingsRouteEnum, SocialMediaRouteEnum } from '~/router/@types';
import { growthbook } from '~/App';
import { ProfileRequestGrowthBookConfig } from '~/types';
import { getEnvironmentKey } from '~/utils';

const SocialMediaListingsPage = lazy(() => import('~/pages/SocialMedia/_impersonation/Listings'));
const SocialMediaReviewNeededPage = lazy(() => import('~/pages/SocialMedia/_impersonation/ReviewNeeded'));
const PiracySocialMediaPage = lazy(() => import('~/pages/SocialMedia/_piracy'));

export const SOCIAL_MEDIA_ROUTES: RouteObject[] = [
  {
    index: true,
    loader: async () => {
      const authData = await getUserInfoQuery();

      if (authData?.use_piracy) {
        return redirect(`${PiracySocialMediaRouteEnum.Detected}`);
      } else {
        return redirect(`${SocialMediaRouteEnum.Listings}/${SocialMediaListingsRouteEnum.Flagged}`);
      }
    },
  },
  {
    path: ':tab/:listingId?',
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <PiracySocialMediaPage />
      </Suspense>
    ),
  },
  {
    path: `${SocialMediaRouteEnum.PiracyListings}/:tab?/:listingId?`,
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <PiracySocialMediaPage />
      </Suspense>
    ),
  },
  {
    path: SocialMediaRouteEnum.ReviewNeeded,
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <SocialMediaReviewNeededPage />
      </Suspense>
    ),
  },
  {
    path: `${SocialMediaRouteEnum.Listings}/:tab?/:listingId?`,
    loader: async ({ params }) => {
      const authData = await getUserInfoQuery();
      const isProfileUrlRequestEnabled = (
        growthbook?.getFeatureValue<ProfileRequestGrowthBookConfig>('PROFILE_REQUEST_ENABLED_CLIENT_IDS', {
          production: [],
          development: [],
        })?.[getEnvironmentKey(import.meta.env.REACT_APP_ENV)] || []
      ).includes(authData?.client_id || -1);

      if (!params.tab) {
        return redirect(`flagged?view_mode=${isProfileUrlRequestEnabled ? 'seller-listing' : 'listing-grid'}`);
      } else {
        return null;
      }
    },
    element: (
      <Suspense fallback={<LoadingCircularProgress open />}>
        <SocialMediaListingsPage />
      </Suspense>
    ),
  },
];
